var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import * as React from 'react';
import { shallowEqual } from 'react-redux';
import { transferToAgentActions } from 'components/shared/transferToAgentModal/actions/transferToAgentModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import styles from './requestTransferAssistButton.module.scss';
export const RequestTransferAssistButton = ({ user, }) => {
    const dispatch = useAppDispatch();
    const { assignedAgent, metaConversation } = useAppSelector((state) => {
        var _a;
        return ({
            assignedAgent: (_a = state.conversation.metaConversation.conversation.assignment) === null || _a === void 0 ? void 0 : _a.agent,
            metaConversation: state.conversation.metaConversation,
        });
    }, shallowEqual);
    const requestTransferAssist = ({ id }) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield bindActionToPromise(dispatch, transferToAgentActions.transferToAgentAssistedRequest)({
                requestToUser: { id },
                requestFromAgent: assignedAgent,
                metaConversation: metaConversation,
            });
        }
        catch (error) {
            console.warn(error);
        }
    });
    const handleOnClick = (event) => {
        event.stopPropagation();
        requestTransferAssist({ id: user.id });
    };
    return (_jsx(Tooltip, Object.assign({ dark: true, content: "Call first", placement: "right" }, { children: _jsx(IconButton, { className: styles.transferToAssistButton, icon: "phone", variant: "tertiary", onClick: handleOnClick }) })));
};
